import React, { useState, useEffect } from 'react';
import HeroContentType from 'containers/user/learn/components/hero-content-type/hero-content-type';
import api from 'api';
import { useCurrentUser } from 'hooks/api/use-current-user';
import Cards from 'containers/user/learn/components/cards/cards';
import NothingFound from 'containers/user/learn/components/empty-row/empty-row';

import { Box } from 'ui/box';
import { Stack } from 'ui/stack';

import { Loader } from 'ui/loader';
import SeeMoreButton from 'containers/user/learn/components/see-more-btn/see-more-btn';

interface DownloadCardItem {
  name?: string;
  route: string;
  coverDescription?: string;
  coverImage?: string;
  date?: string;
}

interface DownloadApiEntry {
  id: string | number;
  attributes?: {
    name?: string;
    coverDescription?: string;
    coverImage?: { data?: { attributes?: { url?: string } } };
    assetCreationDate?: string;
  };
}

const Downloads = (): React.JSX.Element => {
  const [downloads, setDownloads] = useState<DownloadCardItem[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [displayAll, setDisplayAll] = useState<boolean>(false);

  const user = useCurrentUser();

  useEffect(() => {
    setLoading(true);
    api
      .getDownloads(user?.data?.oktaUserId ?? '')
      .then((res) => {
        const data = (res as { data?: { data?: DownloadApiEntry[] } })?.data
          ?.data;

        setDownloads(
          data?.map((el) => ({
            name: el.attributes?.name,
            route: `/learn/content/downloads/${el.id}`,
            coverDescription: el.attributes?.coverDescription,
            coverImage: el.attributes?.coverImage?.data?.attributes?.url,
            date: el.attributes?.assetCreationDate,
          })) ?? []
        );
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const displayedDownloads =
    displayAll || downloads.length < 10 ? downloads : downloads.slice(0, 9);

  return (
    <Box sx={{ width: '100%' }}>
      <Loader loading={loading} />
      <HeroContentType
        title="Downloads"
        description="Access the latest infographics, white papers, and case studies filled with expert insights, analysis, and recommendations for navigating the higher ed marketplace."
        breadcrumbs={[
          { label: 'Learn', href: '/learn' },
          { label: 'Downloads', isActive: true },
        ]}
        customClass="pt-5"
      />
      <Stack sx={{ alignItems: 'center', mt: 5 }}>
        {!displayedDownloads.length && !loading ? (
          <NothingFound contentType="downloads" />
        ) : (
          <Cards items={displayedDownloads} contentType="Download" />
        )}

        {downloads.length > 9 && (
          <SeeMoreButton
            onClick={() => setDisplayAll(!displayAll)}
            showAll={displayAll}
          />
        )}
      </Stack>
    </Box>
  );
};

export default Downloads;
